var _defs, _rect, _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPickleball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "redFace",
    cx: 0.4,
    cy: 0.4,
    r: 0.7
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f44336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#b71c1c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "grip",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6d4c41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3e2723"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 96,
    rx: 36,
    ry: 36,
    width: 200,
    height: 240,
    fill: "url(#redFace)",
    stroke: "#7f0f0f",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M218,336 Q210,360 216,390 Q222,412 246,412 Q270,412 276,390 Q282,360 272,336 Z",
    fill: "url(#grip)",
    stroke: "#2e1d14",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M220,348 L270,348 M218,362 L272,362 M220,376 L270,376",
    stroke: "#a1887f",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 135,
    r: 26,
    fill: "#ffeb3b",
    stroke: "#f9a825",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 358,
    cy: 125,
    r: 3,
    fill: "#f57f17"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 382,
    cy: 142,
    r: 3,
    fill: "#f57f17"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 372,
    cy: 133,
    r: 3,
    fill: "#f57f17"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 366,
    cy: 147,
    r: 3,
    fill: "#f57f17"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 378,
    cy: 122,
    r: 3,
    fill: "#f57f17"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 140,
    r: 3,
    fill: "#f57f17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickleball);
export default __webpack_public_path__ + "static/media/pickleball.f3121396dafb8be6964ba643976bd25a.svg";
export { ForwardRef as ReactComponent };